import { useEffect } from "react";
import toast, { Toaster, useToasterStore } from "react-hot-toast";

const ToasterComponent = () => {
  const { toasts } = useToasterStore();
  const TOAST_LIMIT = 1;

  useEffect(() => {
    const visibleToasts = toasts.filter((t) => t.visible);

    if (visibleToasts.length > TOAST_LIMIT) {
      visibleToasts.slice(TOAST_LIMIT).forEach((t) => toast.dismiss(t.id));
    }
  }, [toasts]);

  return <Toaster position="bottom-center" toastOptions={{ style: { maxWidth: 800, textAlign: 'center' }, duration: 2500 }} />;
};

export default ToasterComponent;
